export enum ImageType {
    FIXED = "fixed",
    FLUID = 'fluid'
}